import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Document from './../../../../../../../components/document';
import { Field } from 'redux-form';
import messages from '../../../../../../../text/messages';
import { TextField, DateField } from '../../../../../../../components/fields';
import { required } from '../../../../../../../utilities/validation';
import { DocumentInfo } from '../../../../../../../utilities/documentTypes';
import { fixDate } from '../../../../../../../utilities/dateTime';

export const getDocumentDetails = type => {
    let types = DocumentInfo.types;
    const documents = {
        A: [
            {
                doc: types.CONTRACTOR_I9_A_US_PASSPORT,
                label: <FormattedHTMLMessage id={'A.choice1'} defaultMessage={'<strong>U.S. Passport</strong>'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_A_US_PASSPORT_CARD,
                label: <FormattedHTMLMessage id={'A.choice1a'} defaultMessage={'<strong>U.S. Passport Card</strong>'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_A_FORM_I551,
                label: (
                    <FormattedHTMLMessage
                        id={'A.choice2'}
                        defaultMessage={'<strong>Green Card</strong> (<em>also known as:</em> I-551, Permanent Resident Card, Alien Registration Receipt Card)'}
                        tagName={'span'}
                    />
                )
            },
            {
                doc: types.CONTRACTOR_I9_A_FPASS_WI551,
                label: (
                    <FormattedHTMLMessage
                        id={'A.choice3'}
                        defaultMessage={'Foreign passport with <strong>temporary I-551</strong> stamp or notation'}
                        tagName={'span'}
                    />
                )
            },
            {
                doc: types.CONTRACTOR_I9_A_FORM_I766,
                label: (
                    <FormattedHTMLMessage
                        id={'A.choice4'}
                        defaultMessage={'<strong>Work Permit</strong>, (<em>also known as:</em> I-766, Employment Authorization Document, EAD)'}
                        tagName={'span'}
                    />
                )
            },
            {
                doc: types.CONTRACTOR_I9_A_NONIMMIGRANT_ALIEN,
                label: <FormattedHTMLMessage id={'A.choice5'} defaultMessage={'Foreign passport with valid <strong>I-94 or I-94A</strong>'} tagName={'span'} />
            }
        ],
        B: [
            {
                doc: types.CONTRACTOR_I9_B_DRIVERS_LICENSE_ID_CARD,
                label: <FormattedHTMLMessage id={'B.choice1'} defaultMessage={"US Driver's license"} tagName={'strong'} />
            },
            { doc: types.CONTRACTOR_I9_B_STATE_ID, label: <FormattedMessage id={'B.choice1a'} defaultMessage={'US State ID card'} tagName={'strong'} /> },
            {
                doc: types.CONTRACTOR_I9_B_FEDERAL_ID_CARD,
                label: <FormattedHTMLMessage id={'B.choice2'} defaultMessage={'<strong>Federal/State/Local Agency ID card</strong>'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_B_SCHOOL_ID_CARD,
                label: <FormattedHTMLMessage id={'B.choice3'} defaultMessage={'<strong>School ID card</strong> with photo'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_B_VOTERS_REGISTRATION_CARD,
                label: <FormattedHTMLMessage id={'B.choice4'} defaultMessage={"<strong>Voter's registration card</strong>"} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_B_US_MILITARY_CARD,
                label: (
                    <FormattedHTMLMessage
                        id={'B.choice5'}
                        defaultMessage={'<strong>U.S. Military card</strong> <em>or</em> <strong>draft record</strong>'}
                        tagName={'span'}
                    />
                )
            },
            {
                doc: types.CONTRACTOR_I9_B_MILITARY_DEPENDENT_CARD,
                label: <FormattedHTMLMessage id={'B.choice6'} defaultMessage={"<strong>Military dependent's ID card</strong>"} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_B_COAST_GUARD_CARD,
                label: <FormattedHTMLMessage id={'B.choice7'} defaultMessage={'<strong>U.S. Coast Guard Merchant Mariner Card</strong>'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_B_NATIVE_AMERICAN_DOC,
                label: <FormattedHTMLMessage id={'B.choice8'} defaultMessage={'<strong>Native American tribal document</strong>'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_B_CANADIAN_DRIVERS_LICENSE,
                label: <FormattedHTMLMessage id={'B.choice9'} defaultMessage={"<strong>Canadian Driver's license</strong>"} tagName={'span'} />
            }
        ],
        C: [
            {
                doc: types.CONTRACTOR_I9_C_SSN_CARD,
                label: <FormattedHTMLMessage id={'C.choice1'} defaultMessage={'<strong>Social Security Account Number card</strong>'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_C_REPORT_OF_BIRTH_FS240,
                label: (
                    <FormattedHTMLMessage id={'C.choice2'} defaultMessage={'<strong>FS-240</strong> Consular Report of Birth Abroad (CRBA)'} tagName={'span'} />
                )
            },
            {
                doc: types.CONTRACTOR_I9_C_REPORT_OF_BIRTH_DS1350,
                label: <FormattedHTMLMessage id={'C.choice2'} defaultMessage={'<strong>DS-1350</strong> Certification of Report of Birth'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_C_REPORT_OF_BIRTH_FS545,
                label: <FormattedHTMLMessage id={'C.choice2'} defaultMessage={'<strong>FS-545</strong> Certification birth'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_C_BIRTH_CERTIFICATE,
                label: <FormattedHTMLMessage id={'C.choice3'} defaultMessage={'Original or certified <strong>US birth certificate</strong>'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_C_NATIVE_AMERICAN_DOC,
                label: <FormattedMessage id={'C.choice4'} defaultMessage={'Native American tribal document'} tagName={'strong'} />
            },
            {
                doc: types.CONTRACTOR_I9_C_CITIZEN_CARD_FORM_I197,
                label: <FormattedHTMLMessage id={'C.choice5'} defaultMessage={'<strong>I-197</strong> US Citizen ID Card'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_C_RESIDENT_CARD_FORM_I197,
                label: <FormattedHTMLMessage id={'C.choice6'} defaultMessage={'<strong>I-179</strong> ID Card for Resident Citizen'} tagName={'span'} />
            },
            {
                doc: types.CONTRACTOR_I9_C_EMPLOYEMENT_AUTH_HS,
                label: (
                    <FormattedHTMLMessage
                        id={'C.choice7'}
                        defaultMessage={'<strong>Employment authorization document</strong> issued by the Department of Homeland Security'}
                        tagName={'span'}
                    />
                )
            }
        ]
    };

    return type !== undefined ? documents[type] : documents;
};

function renderDocumentUpload(choice, listType, docType, displayName, i9_fields) {
    if (choice !== docType) {
        return null;
    }

    const typeData = i9_fields[listType];
    let expDate = typeData ? fixDate(typeData.expDate) : null;
    if (expDate === 'Invalid date') {
        expDate = null;
    }

    return (
        <div className="i9-doc-attach">
            <div className="group">
                <Document
                    id={`i9-${listType}-${docType}`}
                    docType={`i9-${listType}-${docType}`}
                    displayName={displayName}
                    upload={{ limit: 1 }}
                    view={{ showHeader: false, component: 'icon-download' }}
                />
            </div>
            <div className="row">
                <div className={`col-xs-12 ${listType === 'A' ? 'col-md-3' : ''}`}>
                    <Field name={`i9_fields.${listType}.issuingAuthority`} component={TextField} validate={required} placeholder={messages.issuingAuthority} />
                </div>
                <div className={`col-xs-12 ${listType === 'A' ? 'col-md-3' : ''}`}>
                    <Field name={`i9_fields.${listType}.docNumber`} component={TextField} validate={required} placeholder={messages.docNumber} />
                </div>
                <div className={`col-xs-12 ${listType === 'A' ? 'col-md-3' : ''}`}>
                    <Field
                        name={`i9_fields.${listType}.expDate`}
                        component={DateField}
                        selectedDate={expDate}
                        validate={required}
                        placeholder={messages.expirationDate}
                    />
                </div>
            </div>
        </div>
    );
}

export function renderOptions(choice, type, i9_fields) {
    const items = getDocumentDetails(type);
    return items.map((details, i) => {
        const { doc, label } = details;
        const { docType, displayName } = doc;
        return {
            value: docType,
            label: (
                <React.Fragment key={i}>
                    <div className="i9-doc-wrap">
                        <i className="material-icons">{choice === docType ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                        {label}
                    </div>
                    {renderDocumentUpload(choice, type, docType, displayName, i9_fields)}
                </React.Fragment>
            )
        };
    });
}

export function getI9DocumentsIntroText() {
    return (
        <div>
            <div className="row intro-paragraph">
                <div className="col-xs-12">
                    <FormattedHTMLMessage
                        id={'i9docs.intro1'}
                        defaultMessage={'To complete the I-9, you will need your original document(s) proving you are authorized to work in the US.'}
                        tagName={'span'}
                    />
                </div>
            </div>
            <div className="row intro-paragraph">
                <div className="col-xs-12">
                    <FormattedHTMLMessage
                        id={'i9docs.antiDiscrimination'}
                        defaultMessage={
                            "There are a number of different documents you can choose from.  <br />Provided they're valid and unexpired, we don't have a preference for any one over another - it's your choice."
                        }
                        tagName="span"
                    />
                </div>
            </div>
            <div className="row intro-paragraph">
                <div className="col-xs-12">
                    <FormattedHTMLMessage
                        id={'i9docs.intro2'}
                        defaultMessage={
                            'In particular, you need to choose below either <em>one from List A</em>, <strong>or</strong> <em>one each from Lists B and C</em>.'
                        }
                        tagName="span"
                    />
                </div>
            </div>
            <div className="row intro-paragraph">
                <div className="col-xs-12">
                    <FormattedHTMLMessage
                        id={'i9docs.intro2'}
                        defaultMessage={
                            'Note that you will need to upload a picture of whatever document(s) you choose, and you will also have to show the original(s) to a witness who can examine them and sign the I-9 form.'
                        }
                        tagName="span"
                    />
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/assets/i9DocType.jsx